(() => {
  if (window.__luxDiscountInit) return;
  window.__luxDiscountInit = true;

  function parseMoney(text) {
    if (!text) return null;
    const cleaned = text.replace(/\s/g, "").replace(/[^\d.,-]/g, "");
    if (!cleaned) return null;

    const hasComma = cleaned.includes(",");
    const hasDot = cleaned.includes(".");
    let normalized = cleaned;

    if (hasComma && hasDot) {
      normalized =
        cleaned.lastIndexOf(".") > cleaned.lastIndexOf(",")
          ? cleaned.replace(/,/g, "")
          : cleaned.replace(/\./g, "").replace(",", ".");
    } else if (hasComma && !hasDot) {
      const parts = cleaned.split(",");
      normalized =
        parts[parts.length - 1].length === 2
          ? cleaned.replace(/\./g, "").replace(",", ".")
          : cleaned.replace(/,/g, "");
    } else {
      normalized = cleaned.replace(/,/g, "");
    }

    const n = Number(normalized);
    return Number.isFinite(n) ? n : null;
  }

  function upsert(priceListEl) {
    const saleEl = priceListEl.querySelector("sale-price");
    const compareEl = priceListEl.querySelector("compare-at-price");
    const existing = priceListEl.querySelector(".lux-discount-percent");

    if (!saleEl || !compareEl) {
      if (existing) existing.remove();
      return;
    }

    const sale = parseMoney(saleEl.textContent);
    const compare = parseMoney(compareEl.textContent);

    if (!sale || !compare || compare <= sale) {
      if (existing) existing.remove();
      return;
    }

    const percent = Math.round(((compare - sale) / compare) * 100);
    if (!percent || percent <= 0) return;

    let badge = existing;
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "lux-discount-percent";
      compareEl.insertAdjacentElement("afterend", badge);
    }
    badge.textContent = `${percent}% off`;
  }

  function runAll() {
    document.querySelectorAll("price-list").forEach(upsert);
  }

  // Debounce so we never run too frequently
  let t = null;
  function scheduleRun() {
    if (t) return;
    t = setTimeout(() => {
      t = null;
      runAll();
    }, 80);
  }

  // Initial pass
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runAll, { once: true });
  } else {
    runAll();
  }

  // Prestige variant changes (best signal on PDPs)
  document.addEventListener("variant:changed", scheduleRun);

  /* --------------------------------------------------------------
     CWV REGRESSION CLEANUP 2026-05-17:
     Previous version used document.body subtree MutationObserver.
     That fires for every DOM change anywhere on the page (Boost
     cards, Klaviyo popups, GTM tag injection, image loads, etc.)
     and contributed to TBT on slow mobile CPUs.

     This refactor scopes the observer to the most specific possible
     container based on page type, and skips observation entirely on
     pages that don't render price-list elements.
  -------------------------------------------------------------- */
  function startScopedObserver() {
    const path = window.location.pathname;
    let target = null;

    if (path.indexOf("/collections/") === 0 || path === "/collections" || path.indexOf("/search") === 0) {
      // Collection / search / Boost grid pages
      target = document.querySelector(".boost-sd__products-list")
        || document.querySelector("[data-section-type='main-collection']")
        || document.querySelector(".main-collection")
        || document.querySelector("[data-section-type='featured-collections']");
    } else if (path.indexOf("/products/") === 0) {
      // PDP
      target = document.querySelector(".product-info")
        || document.querySelector("[data-section-type='main-product']");
    } else if (path === "/" || path === "") {
      // Home: featured collections / recently viewed
      target = document.querySelector("[data-section-type='featured-collections']")
        || document.querySelector("[data-section-type='recently-viewed-products']");
    } else if (path === "/cart" || path.indexOf("/cart") === 0) {
      target = document.querySelector("[data-section-type='main-cart']")
        || document.querySelector(".main-cart");
    }

    if (!target) return; // No price-list-bearing container on this page → no observer

    const obs = new MutationObserver(() => scheduleRun());
    obs.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startScopedObserver, { once: true });
  } else {
    startScopedObserver();
  }
})();
